import Vue from 'vue';
import store from '@/store/index';
import EventBus from '@/plugins/eventBus';

export default {
  SET_SIDEBAR(state, payload) {
    state.sidebar = payload;
  },
  setLoginError(state, payload) {
    state.loginError = payload;
  },
  setGameplayToken(state, payload) {
    state.gameplayToken = payload;
  },
  setFriendList(state, payload) {
    state.userFriends = payload;
  },
  setAllUserFriends(state, payload) {
    state.allUserFriends = payload;
  },
  setAcceptedFriendsList(state, payload) {
    state.userFriendsAccepted = payload;
  },
  setRejectedFriendList(state, payload) {
    state.userFriendsRejected = payload;
  },
  setBlockedFriendList(state, payload) {
    state.userFriendsBlocked = payload;
  },
  setSentFriendList(state, payload) {
    state.userFriendsSent = payload;
  },
  setWalletDialog(state, payload) {
    state.walletDialog = payload;
  },
  setReceivedFriendList(state, payload) {
    state.userFriendsReceived = payload;
  },
  setError(state, payload) {
    state.error = payload;
  },
  setIsOlympusAvailable(state, payload) {
    state.isOlympusAvailable = payload;
  },
  setIsMultiPlinkoLimitedAvailable(state, payload) {
    state.isMultiPlinkoLimitedAvailable = payload;
  },
  setCurrentUserId(state, payload) {
    state.currentUserID = payload;
  },
  clearError(state) {
    state.error = null;
  },
  clearLoginResponse(state) {
    state.loginError = null;
  },
  setPrivateRoomURL(state, payload) {
    state.privateRoomURL = payload;
  },
  setReferrals(state, payload) {
    state.allReferrals = payload;
  },
  setPossibleFriends(state, payload) {
    state.possibleFriends = payload;
  },
  setIsManualSignIn(state, payload) {
    state.isManualSignIn = payload;
  },
  setUser(state, payload) {
    if (payload) {
      localStorage.setItem('user', JSON.stringify(payload));

      if (payload.suspended) {
        state.userSuspended = payload.suspended;
        EventBus.emit('user-suspended');
      }
    } else {
      localStorage.removeItem('user');
      localStorage.removeItem('session');

      state.firebaseToken = null;
      state.userSuspended = false;
      state.isLoggedIn = false;
    }

    state.user = payload;
    state.userCheckCompleted = true;
  },
  withdrawalReservations(state, payload) {
    state.withdrawalReservations = payload;
  },
  setUserTotalWithdrawalRequests(state, payload) {
    state.totalUserWithdrawalRequests = payload;
  },
  setLoadedAlerts(state, payload) {
    state.alerts = payload;
  },
  appendLoadedAlerts(state, payload) {
    let addNew = true;
    for (let value in state.alerts) {
      if (state.alerts[value].key === payload.key) {
        Vue.set(state.alerts, value, payload);
        addNew = false;
      }
    }

    if (addNew) {
      state.alerts.push(payload);
    }
  },
  appendUserBlockedFrom(state, payload) {
    let friend = {
      ...payload,
      image: 'Profile_Pic.png',
      key: payload.friendId,
    };
    let addNew = true;

    for (let value in state.userBlockedFrom) {
      if (state.userBlockedFrom[value].friendId === friend.friendId) {
        state.userBlockedFrom[value] = friend;
        addNew = false;
      }
    }

    if (addNew) {
      state.userBlockedFrom.push(friend);
    }
  },

  removeFromListOfUserBlockedFrom(state, payload) {
    for (let value in state.userBlockedFrom) {
      if (state.userBlockedFrom[value].friendId === payload.friendId) {
        state.userBlockedFrom.splice(value, 1);
      }
    }
  },

  updateFriendOnlineStatus(state, { displayName, isOnline }) {
    const friendIdx = state.allUserFriends.findIndex((f) => f.displayName === displayName);
    if (friendIdx === -1) return;

    Vue.set(state.allUserFriends, friendIdx, {
      ...state.allUserFriends[friendIdx],
      online: isOnline,
    });
  },

  updateChallengeOnlineStatus(state, { displayName, isOnline }) {
    state.challenges = state.challenges.map((challenge) => {
      if (challenge.displayName === displayName) {
        challenge.online = isOnline;
      }
      return challenge;
    });
  },

  updateAlertOnlineStatus(state, { displayName, isOnline }) {
    state.alerts = state.alerts.map((alert) => {
      if (alert.displayName === displayName) {
        alert.online = isOnline;
      }
      return alert;
    });
  },

  updateLastPlayedWithOnlineStatus(state, { displayName, isOnline }) {
    const player = state.lastPlayedWith.find((p) => p.displayName === displayName);
    if (player) {
      player.online = isOnline;
    }
  },

  appendLastPlayedWith(state, payload) {
    let addNew = true;

    for (let value in state.lastPlayedWith) {
      if (state.lastPlayedWith[value].displayName === payload.displayName) {
        state.lastPlayedWith[value] = payload;
        addNew = false;
      }
    }

    if (addNew) {
      state.lastPlayedWith.push(payload);
    }
  },

  appendOnlineUsers(state, payload) {
    state.onlineUsersFromList = [...payload];
  },

  removeOnlineUser(state, userName) {
    state.onlineUsersFromList = state.onlineUsersFromList.filter((user) => user.displayName !== userName);
  },

  removeFromListOfLastPlayedWith(state, payload) {
    for (let value in state.lastPlayedWith) {
      if (state.lastPlayedWith[value].displayName === payload.displayName) {
        state.lastPlayedWith[value].databaseRef?.off();
        state.lastPlayedWith.splice(value, 1);
      }
    }
  },

  appendListOfFriends(state, payload) {
    const friend = {
      ...payload,
      image: 'Profile_Pic.png',
      key: payload.friendId,
    };

    const idx = state.allUserFriends.findIndex((f) => f.friendId === friend.friendId);

    if (idx === -1) {
      state.allUserFriends.push(friend);
    } else {
      Vue.set(state.allUserFriends, idx, friend);
    }

    state.userFriendsAccepted = state.allUserFriends.filter(({ status }) => status === 'friend');
    state.userFriendsRejected = state.allUserFriends.filter(({ status }) => status === 'rejected');
    state.userFriendsBlocked = state.allUserFriends.filter(({ status }) => status === 'blocked');
    state.userFriendsSent = state.allUserFriends.filter(({ status }) => status === 'sent');
    state.userFriendsReceived = state.allUserFriends.filter(({ status }) => status === 'received');
  },

  removeFromListOfFriends(state, payload) {
    const index = state.allUserFriends.findIndex((friend) => friend.friendId === payload.friendId);

    if (index !== -1) {
      state.allUserFriends[index].databaseRef?.off();
      state.allUserFriends.splice(index, 1);
    }

    state.userFriendsAccepted = state.allUserFriends.filter(({ status }) => status === 'friend');
    state.userFriendsRejected = state.allUserFriends.filter(({ status }) => status === 'rejected');
    state.userFriendsBlocked = state.allUserFriends.filter(({ status }) => status === 'blocked');
    state.userFriendsSent = state.allUserFriends.filter(({ status }) => status === 'sent');
    state.userFriendsReceived = state.allUserFriends.filter(({ status }) => status === 'received');
  },
  setListOfActiveGames(state, payload) {
    state.activeGames = payload;
  },
  appendListOfActiveGames(state, payload) {
    for (let value in state.activeGames) {
      if (state.activeGames[value].key === payload.key) {
        Vue.set(state.activeGames, value, payload);
        return;
      }
    }
    state.activeGames.push(payload);
  },
  removeFromListOfActiveGames(state, payload) {
    for (let value in state.activeGames) {
      if (state.activeGames[value].key === payload.key) {
        state.activeGames.splice(value, 1);
      }
    }
  },
  setcurrentchallenge(state, payload) {
    state.acceptedchallenge = payload;
  },
  appendLoadedChallenges(state, payload) {
    for (let value in state.challenges) {
      if (state.challenges[value].key === payload.key) {
        Vue.set(state.challenges, value, payload);
        return;
      }
    }
    state.challenges.push(payload);
  },
  appendUnseenChallenges(state, payload) {
    store.dispatch('showNotificationTooltip', payload.message);

    for (let value in state.unseenChallenges) {
      if (state.unseenChallenges[value].key === payload.key) {
        Vue.set(state.unseenChallenges, value, payload);
        return;
      }
    }

    state.unseenChallenges.push(payload);
  },
  removeLoadedPrivateRooms(state, payload) {
    for (let value in state.privateRooms) {
      if (state.privateRooms[value].privateRoomId === payload.privateRoomId) {
        state.privateRooms.splice(value, 1);
      }
    }
  },
  setNewNotification(state, payload) {
    state.newNotification = payload;
  },
  appendLoadedPrivateRooms(state, payload) {
    for (let value in state.privateRooms) {
      if (state.privateRooms[value].privateRoomId === payload.privateRoomId) {
        state.privateRooms.splice(value, 1);
      }
    }
    state.privateRooms.push(payload);
  },
  removeUnseenChallenge(state, payload) {
    for (const challengeIndex in state.unseenChallenges) {
      if (state.unseenChallenges[challengeIndex].roomId === payload.roomId) {
        state.unseenChallenges.splice(challengeIndex, 1);
        break;
      }
    }
  },
  setLoadedChallenges(state, payload) {
    state.challenges = payload;
  },
  setLoading(state, payload) {
    state.isloading = payload;
  },
  setReferralLink(state, payload) {
    state.referralLink = payload;
  },
  setOrderStatus(state, payload) {
    state.orderStatus = payload;
  },
  setUserTotalBalance(state) {
    const balance = {
      MMC:
        (parseInt(state.depositBalance?.balance?.MMC, 10) || 0) +
        (parseInt(state.withdrawableBalance?.balance?.MMC, 10) || 0),
      MQC:
        (parseInt(state.depositBalance?.balance?.MQC, 10) || 0) +
        (parseInt(state.withdrawableBalance?.balance?.MQC, 10) || 0),
    };

    state.totalBalance = { balance };
  },
  setUserDepositBalance(state, payload) {
    if (state.depositBalance?.balance && payload.balance) {
      state.totalBalance.balance.MQC -= parseInt(state.depositBalance.balance.MQC, 10);
      state.totalBalance.balance.MMC -= parseInt(state.depositBalance.balance.MMC, 10);
    }

    state.depositBalance = payload;

    this.commit('setUserTotalBalance');
  },
  // setUserBonusBalance(state, payload) {
  //   state.bonusBalance = payload;
  // },
  setUserWithdrawableBalance(state, payload) {
    if (state.withdrawableBalance?.balance && payload.balance) {
      state.totalBalance.balance.MQC -= parseInt(state.withdrawableBalance.balance.MQC, 10);
      state.totalBalance.balance.MMC -= parseInt(state.withdrawableBalance.balance.MMC, 10);
    }

    state.withdrawableBalance = payload;
    this.commit('setUserTotalBalance');
  },

  setUserReferralRewardData(state, payload) {
    state.userReferralRewardsData.balance = payload.balance;
    state.userReferralRewardsData.count = payload.count;
  },
  setGlobalAffiliateConfig(state, payload) {
    state.globalAffiliateConfig = payload;
  },
  setGlobalConfig(state, payload) {
    state.globalConfig = payload;
  },
  setPlayerMode(state, payload) {
    state.playermode = payload;
    localStorage.setItem('currency', payload);
  },
  setRoomsPlayerNumber(state, roomsPlayerNumber) {
    state.roomsPlayerNumber = roomsPlayerNumber;
  },
  setTransHistory(state, payload) {
    state.transHistory = payload;
  },
  // setBonusHistory(state, payload) {
  //   state.bonusHistory = payload;
  // },
  setPackages(state, payload) {
    state.packages = payload;
  },
  setPlayerInfo(state, payload) {
    state.playerInfo = payload;
  },
  setGameHistory(state, payload) {
    state.gameHistory = payload;
  },
  setPrivateRoomID(state, payload) {
    state.privateRoomID = payload;
  },
  setHomeUrl(state, payload) {
    state.homeUrl = payload;
  },
  setLastPlayedWith(state, payload) {
    state.lastPlayedWith = payload;
  },
  setGameWindow(state, payload) {
    state.gameWindow = payload;
  },

  setSumsubAccessToken(state, payload) {
    state.sumsubAccessToken = payload;
  },

  appendReferrals(state, payload) {
    for (let value in state.allReferrals) {
      if (state.allReferrals[value].displayName === payload.displayName) {
        state.allReferrals.splice(value, 1);
      }
    }
    state.allReferrals.push(payload);
  },
  removeReferral(state, payload) {
    for (const referralIndex in state.allReferrals) {
      if (state.allReferrals[referralIndex].displayName === payload.displayName) {
        state.allReferrals.splice(referralIndex, 1);
        break;
      }
    }
  },
  // setAvailableBonuses(state, payload) {
  //   state.availableBonuses = payload;
  // },
  // setAllActiveBonuses(state, payload) {
  //   state.allActiveBonuses = payload;
  // },
  // setUnclaimedBonuses(state, payload) {
  //   state.unclaimedBonuses = payload;
  // },
  setUserBoughtPackages(state, payload) {
    state.boughtPackages = payload || {};
  },

  SET_FIREBASE_TOKEN(state, data) {
    state.firebaseToken = data.token;
    state.firebaseTokenExpirationTime = data.expirationTime;
  },

  SET_PACKAGES_PENDING(state, value) {
    state.packagesPending = value;
  },

  SET_PENDING_FLAG(state, [key, value]) {
    Vue.set(state.pendingFlags, key, value);
  },

  SET_SOCIAL_SIGN_UP(state, value) {
    state.isSocialSignUp = value;
  },

  SET_TOTAL_NOTIFICATION_AMOUNT(state, value) {
    state.totalNotificationAmount = value;
  },

  SET_CASHIER_CURRENCIES(state, value) {
    state.cashierCurrencies = value;
  },

  SET_LEFT_NAVBAR_OPEN(state, value) {
    state.leftNavbarOpen = value;
  },

  SET_USER_CHECK_COMPLETED(state, value) {
    state.userCheckCompleted = value;
  },

  SET_LOGGED_IN(state, value) {
    state.isLoggedIn = value;
  },

  SET_INVOICE_ABORT_CTRL(state, value) {
    state.invoiceAbortCtrl = value;
  },

  SET_PHONE_VERIFIED(state, payload) {
    let playerInfo;

    if (state.playerInfo) {
      playerInfo = { ...state.playerInfo };
      playerInfo.profile.phoneVerified = payload;
      if (playerInfo.profile.phoneNumber) playerInfo.profile.phoneNumber.verified = payload;
    } else {
      playerInfo = { status: '', profile: { phoneVerified: payload, phoneNumber: { verified: payload } } };
    }

    state.playerInfo = playerInfo;
  },

  SET_EMAIL_VERIFIED(state, payload) {
    let playerInfo;

    if (state.playerInfo) {
      playerInfo = { ...state.playerInfo };
      playerInfo.profile.emailVerified = payload;
    } else {
      playerInfo = { status: '', profile: { emailVerified: payload } };
    }

    state.playerInfo = playerInfo;
  },

  SET_PRIVATE_ROOMS(state, payload) {
    state.privateRooms = payload;
  },
};
